module.exports = __webpack_public_path__ + "img/report-4.8c699aa2.png";